import React, { FC, ReactElement, useEffect } from 'react'
import FaqQuestion from '../../components/faqQuestion'
import { useContact } from '../../hooks/faq'
import { RoutesEnum } from '../../utils/routesEnum'
import Default from '../loggedArea/default'

export const Faq: FC<{ isOpen?: boolean }> = ({ isOpen }): ReactElement => {
  const { faq, getFaq } = useContact()

  useEffect(() => {
    getFaq()
  }, [getFaq])

  return (
    <>
      {faq.map(question => (
        <FaqQuestion
          defaultIsOpen={isOpen}
          key={question.text}
          title={question.title}
          content={question.text}
        />
      ))}
    </>
  )
}

const FAQandLoggedArea: FC = (): ReactElement => {
  return (
    <div>
      <Default
        breadcrumbs={[
          { title: 'Ajuda e Suporte', to: RoutesEnum.FAQ },
          { title: 'F.A.Q', to: RoutesEnum.FAQ }
        ]}
        title='F.A.Q.'
        subtitle='Tire suas duvidas aqui!'
      >
        <Faq isOpen />
      </Default>
    </div>
  )
}

export default FAQandLoggedArea
